// Lib
import { useState } from "react"
import { Button, FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, InputGroup, InputRightAddon, InputRightElement } from "@chakra-ui/react"

// Components
import { Icon } from "components"

export default function Password({ label, error, helper, ...props }){

    const [ show, setShow ] = useState()

    return(
    <FormControl isInvalid={!!error}>
        { label && <FormLabel children={label} /> }
        <InputGroup>
            <Input type={ show ? 'text' : 'password'} autoComplete="off" {...props} />
            <InputRightElement><Button isDisabled={props?.isDisabled} size="xs" onClick={() => setShow(!show)}><Icon name={show ? 'hidden' : 'visible'} /></Button></InputRightElement>
        </InputGroup>
        { !!error && <FormErrorMessage children={error} /> }
        { (!error && !!helper) && <FormHelperText children={helper} />}
    </FormControl>
    )
}